import defaultState from './defaultState'
import { actionTypes } from '../../../actions/src'

const subscriberReducer = (state = { ...defaultState }, { type, payload }) => {

  switch (type) {

    case actionTypes.FETCH_SUBSCRIBER_LIST:
      return {
        ...state,
        status: {
          isLoading: true,
          error: null
        },
        subscribers: [],
        total: 0
      }
    case actionTypes.FETCH_SUBSCRIBER_LIST_SUCCESSFUL:
      return {
        ...state,
        status: {
          isLoading: false,
          error: null
        },
        subscribers: payload.data,
        total: payload.total
      }
    case actionTypes.FETCH_SUBSCRIBER_LIST_FAILED:
      return {
        ...state,
        status: {
          isLoading: false,
          error: payload.data
        },
        subscribers: [],
        total: 0
      }
    default:
      return state

  }

}

export default subscriberReducer
